module.exports = __webpack_public_path__ + "img/HZ3605-173.16d59f34.jpg";